<div class="profile-dialog">
    <!-- Encabezado -->
    <div class="dialog-header">
        <h2 mat-dialog-title>Mi perfil</h2>
        <button mat-icon-button (click)="onClose()" matTooltip="Cerrar" [disabled]="isSaving()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-divider></mat-divider>

    <mat-dialog-content class="dialog-body">

        <!-- Avatar editable -->
        <div class="avatar-section">
            <div class="avatar-wrapper" (click)="onPickFile()" [class.uploading]="isUploading()">
                @if (imageUrl()) {
                    <img [src]="imageUrl()" alt="avatar" class="avatar-img" />
                } @else {
                    <div class="avatar-fallback">{{ initials() }}</div>
                }

                @if (isUploading()) {
                    <div class="avatar-overlay">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>
                } @else {
                    <div class="avatar-hover">
                        <mat-icon>photo_camera</mat-icon>
                        <span>Cambiar</span>
                    </div>
                }
            </div>

            <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="onPickFile()"
                [disabled]="isUploading() || isSaving()"
                class="change-photo-btn"
            >
                <mat-icon>cloud_upload</mat-icon>
                {{ imageUrl() ? 'Cambiar foto' : 'Subir foto' }}
            </button>

            <p class="upload-hint">JPG, PNG, WEBP o GIF. Máx 10 MB.</p>
        </div>

        <mat-divider></mat-divider>

        <!-- Datos del usuario -->
        <form [formGroup]="form" class="profile-form">

            <!-- Nombre (editable) -->
            <mat-form-field appearance="outline">
                <mat-label>Nombre completo</mat-label>
                <input matInput formControlName="name" placeholder="Tu nombre" />
                <mat-icon matPrefix>person</mat-icon>
                @if (fieldError('name')) {<mat-error>El nombre es requerido (mín. 2 caracteres)</mat-error>}
            </mat-form-field>

            <!-- Email (read-only) -->
            <mat-form-field appearance="outline" class="readonly-field">
                <mat-label>Correo electrónico</mat-label>
                <input matInput [value]="user()?.email ?? ''" readonly disabled />
                <mat-icon matPrefix>email</mat-icon>
                <mat-hint>El correo no se puede modificar</mat-hint>
            </mat-form-field>

            <!-- Teléfono celular (editable) -->
            <mat-form-field appearance="outline">
                <mat-label>Teléfono celular</mat-label>
                <input matInput
                       formControlName="phone"
                       type="tel"
                       inputmode="tel"
                       placeholder="ej. +52 55 1234 5678" />
                <mat-icon matPrefix>phone</mat-icon>
                @if (fieldError('phone', 'pattern')) {<mat-error>Solo se permiten dígitos, espacios, +, ( ) y - (máx 20 caracteres)</mat-error>}
            </mat-form-field>

            <!-- Área (editable) -->
            <mat-form-field appearance="outline">
                <mat-label>Área</mat-label>
                <input matInput
                       formControlName="area"
                       placeholder="ej. Ingeniería Biomédica" />
                <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            <!-- Rol (read-only) -->
            <mat-form-field appearance="outline" class="readonly-field">
                <mat-label>Rol asignado</mat-label>
                <input matInput [value]="roleName()" readonly disabled />
                <mat-icon matPrefix>badge</mat-icon>
                @if (!user()?.role) {<mat-hint>Contacta al responsable para que te asigne un rol</mat-hint>}
            </mat-form-field>

            <!-- Número de empleado (editable) -->
            <mat-form-field appearance="outline">
                <mat-label>Número de empleado</mat-label>
                <input matInput formControlName="employeeNumber" placeholder="ej. 10245" />
                <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            <!-- Número de ingeniero (solo si el rol es de ingeniero) -->
            @if (isBiomedicalEngineer()) {
                <mat-form-field appearance="outline">
                    <mat-label>Número de ingeniero</mat-label>
                    <input matInput formControlName="engineerNumber" placeholder="ej. ING-0123" />
                    <mat-icon matPrefix>engineering</mat-icon>
                </mat-form-field>
            }

        </form>

    </mat-dialog-content>

    <mat-divider></mat-divider>

    <mat-dialog-actions class="dialog-actions">
        <button mat-button type="button" (click)="onClose()" [disabled]="isSaving()">
            Cancelar
        </button>
        <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="onSave()"
            [disabled]="isSaving() || isUploading()"
        >
            @if (isSaving()) {<mat-spinner diameter="18"></mat-spinner>} @else {<mat-icon>save</mat-icon>}
            <span>Guardar cambios</span>
        </button>
    </mat-dialog-actions>
</div>
